import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import AddressModule from './modules/AddressModule';
import AuthModule from './modules/AuthModule';
import DashboardModule from './modules/DashboardModule';
import InterviewModule from './modules/InterviewModule';

Vue.use(Vuex);

const vuexPersist = new VuexPersistence({
	strictMode: true,
	storage: window.sessionStorage
})

const getters = {

};

const mutations = {
	RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
};

const actions = {

};

export default new Vuex.Store({
	modules: {
		AddressModule,
		AuthModule,
		DashboardModule,
		InterviewModule
	},
	mutations,
	actions,
	plugins: [vuexPersist.plugin],
	strict: process.env.NODE_ENV !== 'production',
});
